import { apiClient, Auth } from '@/shared/api'

type THostPayCompleteCalendar = {
  startDate: string
  endDate: string
}

export const getHostPayCompleteCalendar = async () => {
  const response = await apiClient.get<THostPayCompleteCalendar>({
    endpoint: `/settlements/complete/calendar`,
    auth: Auth.REQUIRED,
  })

  return response
}
